import Header from './header.vue';
export default Header;


// WEBPACK FOOTER //
// ./src/components/header/index.js